import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';

/**
 * Desktop half of lean computer-use observation. Off: every accessibility
 * result still carries a full PNG. On: Rust diffs the tree and skips the
 * screenshot after a successful write.
 */
export const CUA_LEAN_OBSERVATION_FLAG_KEY = 'release-scribe-work-cua-lean-observation';

export const useIsCuaLeanObservationEnabled = (): boolean =>
  useFeatureFlagEnabled(CUA_LEAN_OBSERVATION_FLAG_KEY) ?? false;
